export default "/images/phone.svg?1f42b883bb23c97af0c63f505a388d78";